import React from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import RightPanel from "./RightPanel";
import { useSelector } from "react-redux";
import numeral from "numeral";
import InKindPassLogo from "../../../../assets/images/icons/inkind-pass-logo.svg";
import InKindLogo from "../../../../assets/images/icons/inkind-logo.png";

const MobileDisclosure = () => {
  const company = useSelector((state) => state.company);
  const ikPass = useSelector((state) => state.nav.ikPass);
  const ikPassSingle = useSelector((state) => state.nav.ikPassSingle);
  const passType = new URLSearchParams(window.location.search).get(
    "utm_content",
  );

  const total_due = numeral(company.presenter.total_due).format("$0,0[.]00");

  const credit_to_give = numeral(
    Number(company.presenter.credit_to_give),
  ).format("$0,0[.]00");
  const bonus_credit = numeral(company.presenter.bonus_credit).format(
    "$0,0[.]00",
  );
  return (
    <div className="checkout-mobile mobile-disclosure ">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosure-button">
              {!open ? (
                <div className="disclosure-grid">
                  {company.presenter.project_logo_white_path ? (
                    <img
                      className="left-img"
                      src={`${company.presenter.cloudinary_path}/h_100/${company.presenter.project_logo_white_path}`}
                    />
                  ) : company.presenter.is_inkind_cash ? (
                    <img src={InKindLogo} className="disclosure-inkind-logo" />
                  ) : null}
                  <div
                    className={
                      company.presenter.project_logo_white_path ||
                      company.presenter.is_inkind_cash
                        ? "details-col "
                        : "details-col-no-img"
                    }
                  >
                    <div className="font-bold company">
                      {!company.presenter.project_name && !ikPassSingle
                        ? "inKind e-Gift Card"
                        : !!ikPassSingle
                          ? "inKind e-Gift Card"
                          : !!company?.presenter?.display_map_siblings
                            ? `${company.presenter.project_name} House Account`
                            : `${company.presenter.brand_name} e-Gift Card`}
                    </div>
                    <span>
                      <div className="inner ">
                        <span className="font-bold ">
                          {company.presenter.bonus_credit === "$0.00" ? (
                            <span>{total_due} E-Gift Card</span>
                          ) : !ikPassSingle ? (
                            <span>
                              {" "}
                              Pay {total_due}, Get {credit_to_give}
                            </span>
                          ) : (
                            <span>
                              {passType === "pg"
                                ? `Pay ${total_due}, Get ${credit_to_give} (${bonus_credit} FREE)`
                                : `Get ${credit_to_give} For ${total_due} (${bonus_credit} FREE)`}
                            </span>
                          )}
                        </span>{" "}
                      </div>
                    </span>
                  </div>
                </div>
              ) : (
                <span className="font-bold">
                  {!company.presenter.project_name && !ikPassSingle
                    ? "inKind e-Gift Card"
                    : !!ikPassSingle
                      ? "inKind e-Gift Card"
                      : !!company?.presenter?.display_map_siblings
                        ? `${company.presenter.project_name} House Account`
                        : `${company.presenter.brand_name} e-Gift Card`}
                </span>
              )}
              <ChevronDownIcon
                className={`${open ? "rotated" : ""} chevron `}
              />
            </Disclosure.Button>
            <Disclosure.Panel>
              <RightPanel />
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default MobileDisclosure;
